(() => {
  const initialize = scope => {
    scope.querySelectorAll('[data-dpr-gallery]').forEach(gallery => {
      if (gallery.dataset.dprGalleryReady) return;
      gallery.dataset.dprGalleryReady = 'true';
      const imageLink = gallery.querySelector('[data-dpr-gallery-link]');
      const status = gallery.querySelector('[data-dpr-gallery-status]');
      const card = gallery.closest('[data-dp-card],.product-card-wrapper');
      if (!imageLink || !card) return;
      card.querySelectorAll('[data-dpr-colour]').forEach(swatch => {
        swatch.addEventListener('click', () => {
          const {variantId, productUrl, productTitle, price, colourLabel, variantTitle, available, imageLabel} = swatch.dataset;
          const source = card.querySelector('template[data-dpr-colour-images="' + variantId + '"]');
          if (!source) return;
          card.querySelectorAll('[data-dpr-colour]').forEach(option => option.setAttribute('aria-pressed', String(option === swatch)));
          imageLink.replaceChildren(source.content.cloneNode(true));
          imageLink.href = productUrl;
          imageLink.setAttribute('aria-label', imageLabel || productTitle);
          card.querySelectorAll('.dpr-image-quick-add input[name="id"]').forEach(input => { input.value = variantId; });
          const purchase = card.querySelector('.dpr-quick-button');
          const actionLabel = available === 'true' ? purchase?.dataset.addLabel : purchase?.dataset.soldOutLabel;
          if (purchase) {
            purchase.disabled = available !== 'true';
            purchase.setAttribute('aria-label', actionLabel + ': ' + productTitle + ' — ' + variantTitle);
            purchase.title = actionLabel;
            purchase.querySelector('[data-dpr-quick-label]').textContent = actionLabel;
            if (!purchase.classList.contains('loading')) purchase.removeAttribute('aria-disabled');
          }
          const badge = gallery.querySelector('[data-dpr-stock-badge]');
          if (badge) badge.hidden = available === 'true';
          card.querySelectorAll('.dpr-image-quick-add .product-form__error-message-wrapper').forEach(error => { error.hidden = true; });
          card.querySelectorAll('h3 a').forEach(link => { link.textContent = productTitle; link.href = productUrl; });
          card.querySelector('.dp-product-card__bottom > a')?.setAttribute('href', productUrl);
          card.querySelectorAll('.dp-product-card__meta > span:last-child,.price-item--regular:not(s),.price-item--sale').forEach(item => { item.textContent = price; });
          const rating = card.querySelector('[data-dpr-rating-slot]');
          const ratingSource = card.querySelector('template[data-dpr-colour-rating="' + variantId + '"]');
          if (rating && ratingSource) rating.replaceChildren(ratingSource.content.cloneNode(true));
          const comparison = card.querySelector('[data-dp-comparison]')?.content;
          if (comparison) {
            comparison.querySelector('h3').textContent = productTitle;
            comparison.querySelector('.dp-compare-price').textContent = price;
            comparison.querySelector('a').href = productUrl;
          }
          if (status) status.textContent = colourLabel + (available === 'true' ? '' : ' · ' + (actionLabel || ''));
        });
      });
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:reorder', () => initialize(document));
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType === 1 && (node.matches('[data-dpr-gallery]') || node.querySelector('[data-dpr-gallery]'))) initialize(node.parentElement || node);
    }));
  }).observe(document.body, {childList:true, subtree:true});
})();
